export default {
    public:{
        subject:'Subject',
        author:'Author',
        select: 'Select',
        item:'Item',
        keywords:'Keyword',
        load:'Loading...',
        nodata:'No data',
        close:'Close',
        all:'All',
        cancel:'Cancel',
        traditionalChinese:'Traditional Chinese',
        thai:'Thai',
        indonesian:'Indonesian',
        malay:'Malay',
        filipino:'Filipino',

        successful:'Registered successfully',
        loginTips: 'Please log in to your personal account',
        loginSuccess: 'Sign in successfully',
        library:'ChatAnswer Library AI Reference System',
        fellows:'ChatFellows Intra-institutional peer discovery/citation system',
        research:'ChatResearch An efficient and personalized academic research platform',
        language:'ChatLanguage Multilingual AI intelligent translation and grammar proofreading system',
        document:'ChatDocuments Deep document parsing tool',
        data:'ChatData Deep table parsing tool',
        other:'Other',
        feedSuccess:'Problem feedback successful!',
        codeTips:'The verification code has been sent, please check it',
        overtime:'Request timed out'
    },
    header:{
        feedback:'Feedback',
        quit:'Quit',
        personal:'Log in to personal account',
       
        language:'Output language',
        username:'Username',
        password:'Password',
        log:'Log in',
        noRegistered:'No account registered',
        register:'Register',
        personalAccount:'Register a personal account',
        accountUsername:'Account/Username',
        tips:'Please enter account/username',
        tipsPassword:'Please enter password',
        confirmPassword:'Confirm Password',
        tipsConfirmPassword:'Please confirm password again',
        email:'Mail',
        tipsEmail:'Please input your email',
        phone:'Phone number',
        tipsPhone:'Please enter phone number',
        verificationCode:'Mobile phone verification code',
        tipsVerificationCode:'Please enter the mobile phone verification code',
        sendVerificationCode:'Obtain',
        back:'Return',
        module:'Functional module',
        selectTip:'Please select the functional module with the problem',
        question:'Problem Description',
        screenshot:'Screenshot of problem',
        upload:'Click to upload',
        type:'Only supports uploading .jpg/.png formats',
        passwordTip:'Please enter a 6-24 digit password',
        enterAgain:'Please enter password again',
        inconsistent:'The passwords entered twice are inconsistent!',
        enterCode:'Please enter verification code',
        emailTip:'Please input the correct email address',
        enterEmail:'Please input the email address',
        otherQuestion:'Do you have any other questions similar to this issue',
        example:'For example',
        bibliography:'Library bibliography',
        logOut:'Are you sure you want to log out of your account',
        sure:'Sure',
        switching:'Switching to multiple languages successfully',
        again:'Resend after',
        again2:'seconds',
        hello:'Hello'
    },
    login:{
        log:'Log in',
        institutionalLogin:'Institutional login',
        personalLogin:'Personal login',
        accountRegistration:'Register an account',
        retrievePassword:'Retrieve password',
        usernameTip:'Please enter your organization username',
        personal:'Please enter your personal username',
        forget:'forget the password?',
        ipLog:'IP login',
        institutional:'Mechanism',
        institutionalTip:'Please select an institution',
        country:'nation',
        countryTip:'Please select a country',
        invitationCode:'Invitation code',
        codeTip: 'Please enter the invitation code',
        newPass:'New Password',
        newPassTip:'Please enter a new password',
        elmaiCode:'E-mail verification code',
        elmaiTip:'Please enter the email verification code',
        resetting:'Reset Password',
        logTip: 'Organization username cannot be empty',

        truePhone:'Please enter correct mobile number',
        successful:'Account registration is successful, please log in again!',
        passwordReset:'Password reset successful, please log in again!',
        noteTitle:'Notes on obtaining verification codes:',
        noteOne:'1. To ensure that the verification code can be delivered promptly and accurately, we recommend using the following email service providers: Gmail, Outlook, Yahoo;',
        noteTwo:'2. Due to the filtering mechanism of each email service provider, sometimes the verification code email may be mistakenly identified as spam or invalid email. Please check whether the verification code email is in the spam recycling bin.',
    },
    chatlibrary:{
        questionOne: 'Inquiries on borrowing',
        questionTwo: 'Inquiries on databases',
        questionThree: 'Inquiries on digital resources',
        quickAccess: 'Quick access',
        disclaimer:'Disclaimer',
        further:'Further questions',
        goon:'Continue',
        statementOne:'1. The responses from ChatAnswer are based on commonly asked questions and publicly available resources. The actual content should be verified with the official information from the library and the original sources.',
        statementTwo:"2. The translation results are for reference only. The platform does not bear any responsibility for the accuracy or reliability of the information obtained from external translation websites, nor for any losses resulting from such reliance. The content in the translated text represents the views of the original author and does not reflect the platform's viewpoint or position of the platform developer.",
        statementThree:'3. The grammar checking feature is only based on linguistic grammar issues and does not reach the level of human language polishing. The platform does not bear any responsibility for any losses resulting from excessive reliance on the results of grammar checking.',
        statementFour:'4. If readers submit manuscripts based on similar recommendation results, they should confirm the periodical information again and contact the editorial department before submission. The platform does not bear any responsibility for any losses resulting from blindly relying on information provided by external websites.',
        statementFive:"5. The viewpoints expressed in the questions, search requests, texts, and uploaded files by readers do not represent the platform's viewpoint and are unrelated to the position of the platform developer.",
        // 手机端
        statementOneMobile:'1. The responses from ChatAnswer are based on commonly asked questions and publicly available resources. The actual content should be verified with the official information from the library and the original sources.',
        statementTwoMobile:"2. The translation results are for reference only. The platform does not bear any responsibility for the accuracy or reliability of the information obtained from external translation websites, nor for any losses resulting from such reliance. The content in the translated text represents the views of the original author and does not reflect the platform's viewpoint or position of the platform developer.",
        statementThreeMobile:'3. The grammar checking feature is only based on linguistic grammar issues and does not reach the level of human language polishing. The platform does not bear any responsibility for any losses resulting from excessive reliance on the results of grammar checking.',
        statementFourMobile:'4. If readers submit manuscripts based on similar recommendation results, they should confirm the periodical information again and contact the editorial department before submission. The platform does not bear any responsibility for any losses resulting from blindly relying on information provided by external websites.',
        statementFiveMobile:"5. The viewpoints expressed in the questions, search requests, texts, and uploaded files by readers do not represent the platform's viewpoint and are unrelated to the position of the platform developer.",
        
        // 进入弹窗文本
        hellow:'Hello: Welcome to your consultation, I am the ',
        introduceOne:' intelligent AI assistant ChatAnswer, I am happy to serve you.',
        introduceTwo:'1. Library opening hours',
        introduceThree:'2. How to find digital resources?',
        introduceFour:'3. What should I do if the borrowed books are accidentally lost?',
        introduceFive:'4. Introduce medical-related databases',
        introduceSix:' 5. How can I access library digital resources off campus?',
        introduceSeven:'You can ask me questions about the library, for example, you can ask me "How to check and find the books you need?" "Library opening hours" "Book borrowing rules", etc. I will try my best to answer you; and about We can also answer questions about books, databases and other library services, such as:',
        questions: 'Further questions',
        Continue:'Continue',
        recording:'Mouse click recording',
        stopRecording:'Click the mouse to stop recording',
        microphone:'Please allow this page to use the microphone first',
        browserTips:'Your browser does not support speech recognition',
        browserTips2:'Your browser does not support sound volume recognition',
        progress:'Speech recognition in progress...',
        failed:'Voice recognition failed',
    },
    chatresearch:{
        theme:'ChatResearch | Semantic Retrieval System',
        themeMobile:'Semantic Retrieval System',
        switchSemantics:'Switch to semantic retrieval mode',
        switchTraditional: 'Switch to normal search mode',
        title: 'Title',
        results:'Featured results',
        year:'Year',
        abstract:'Abstract',
        tips:'Please type search terms here ...',
        select:'Please select',
        issn:'ISSN',
        introduce_tit:'Platform Introduction',
        introduceOne:'ChatResearch will use artificial intelligence and advanced technology to provide readers with a more comprehensive, personalized and efficient academic research platform. Core features include:',
        introduceTwo:"Cross-language semantic search system: Through in-depth understanding of readers' search intentions and interests, as well as cross-language knowledge graphs, the ChatResearch platform's cross-language semantic search system will provide more comprehensive and accurate search results.",
        introduceThree:'Batch document management: Batch document management tools can help researchers, scholars and other groups quickly process large amounts of document content. They can implement classification, annotation, search, filtering, annotation, downloading and a variety of automated functions, thereby greatly improving document management and scientific research efficiency.',
        search:'Traditional logical search',
        searchAll:'Search all',
        searchTip:'You can use the full text of the abstract, paragraphs from the literature, or detailed description text as the search content. The system can implement semantic retrieval based on semantic similarity comparison. The longer the input content, the more accurate the matching effect.',
        clear:'Clear search',
        link:'Article link',
        Similar:'Similar documents',
        followingresults:'Search the following results',
        chinese:'Chinese',
        english:'English',
        total:"Return the total number of results",
        introduceFour:'A subject discovery system based on semantic analysis and similarity matching, which can achieve efficient and intelligent retrieval across languages.',
        volume:'Please select search volume',

        inputTips:'The content of the current input box cannot be empty!'
    },
    chatlanguage: {
        enter: 'Enter',
        errorChecking: 'Find grammatical errors in English',
        CToE: 'Chinese to English',
        EToC: 'English to Chinese',
        docTran: 'Translation of translation documents',
        functionIntroduction: 'Features',
        introduceOne: 'You can use the "English Find Grammar Errors" function to perform intelligent grammar proofreading of English text content. After inputting content, the system can intelligently identify and correct grammatical problems in the paper. It supports the correction of sentence structure, tense, subject and predicate usage, punctuation and other types of problems, helping to improve the quality of the article and enhance readability and accuracy of expression.',
        introduceTwo: 'You can use the "English Academic Polishing" function to polish and optimize English text. The system will modify the text from the perspective of fluency and elegance to make it more smooth and concise. Add professional charm to the text and make the theme ideas appear more clearly.',
        tips: 'Please enter the query contents',
        basic:'Basic functions',
        polish:'English academic polish',
        inputTips:'Please enter the text content that needs proofreading or polishing',

        againRequest:'Request failed! Please try again!',
    },
    chatfellows:{
        introduceOne:'Institutional Peer Citation System——Standing on the shoulders of predecessors',
        introduceTwo:'Introduction',
        introduceThree_one:'ChatFellows',
        introduceThree_two:'Achievements Intelligent Discovery Platform is an intelligent academic retrieval tool specially created for',
        introduceThree:'researchers. Based on the comprehensive integration of institutional results, semantic similarity calculation, vectorization technology, natural language perception and other technologies are applied to achieve in-depth and multi-dimensional utilization of results, achieve intelligent and accurate result matching, similarity sorting, and realize cross-language retrieval and Matching, effectively assisting scientific researchers in carrying out scientific research and writing work such as academic literature research, reference retrieval, and journal selection.',
        introduceFour:'Achievements Intelligent Discovery Platform is fully integrated and brings together the key research results of our school. Through the in-depth application of intelligent AI technology, the results can be effectively applied and assist in the effective development of scientific research work. It is committed to helping users quickly and accurately find high-quality papers in related fields, improve research efficiency, and help achieve academic results. Stand on the shoulders of giants and continue to promote the continuous progress of academic research.',
        introduceFive:'Core functions',
        introduceSix:'Intelligent matching retrieval: realize the efficient discovery of similar papers in our school’s important evaluation source results.',
        introduceSeven:'Cross-language retrieval: Through the application of vectorization technology, retrieval and matching are realized without language restrictions.',
        introduceTen:'Similarity optimization sorting: The optimal matching results are presented based on the similarity of the papers, making it easier for scientific readers to quickly locate the most relevant research results.',
        introduceEight:'Detailed information display: The platform provides detailed literature information of the search results and summary translations of foreign language results, allowing users to quickly understand the gist of the results.',
        introduceNine:'Highly timely updates: The platform regularly synchronizes important evaluation source databases to ensure that readers can grasp the latest results.',
        knowBtn:'Got it!',
        enter:'Enter here',
        title:'Institutional Peer Citation System——Standing on the shoulders of predecessors',
        tips:'Please enter the abstract or topic of the article you want to search for (title, keywords, etc.), and the system will help you identify similar papers (no special translation and conversion is required).',
        submit:'Submit',
        relatedLiterature:'Related literature',
        year:'Years',

        enSummary:'abstract',
        cnSummary:'Chinese abstract',
    },
    chatdocument:{
        title:'File Analysis Tool',
        introduce:'To achieve the extraction of content and full-text analysis of specified topics and scopes of document data, in order to assist in conducting in-depth research.',
        start:'Start experiencing',
        ask:'Ask questions about the current documentation and get the answers',
        createSession:'A conversation and ask questions on multiple documents simultaneously',
        quoting:'Quoting passages and in-depth analysis of  contents',
        analyze:'Analyze charts and extract data for comprehensive analysis',
        tool:"File Analysis Tool",
        list:'File list',
        conversation:'Conversation list',
        createAsk:'Create a conversation',
        upload:'File Upload',
        drag:'Drag in files or click to upload',
        introduceOne:'Ask questions about document content and get answers instantly through chat.',
        introduceTwo:'ChatDocuments is a file analysis tool that can quickly extract, locate, and summarize information from documents.',
        quick:'Quick Access',
        enter:'Please enter contents...',
        askQuestion:'Ask a question',
        example:'Example',
        busy:'Service is busy, please try again',
        stop:'Stop answering',
        onlyAsk:'Only ask questions about the current article',
        chapter:'Chapter',
        create:'Create',
        editsession:'Edit session',
        sessionname:'Session name',
        currentlyselected:'Currently selected',
        fileselection:'File selection',
        revise:'Revise',
        docLanguage:'Document language',
        zhDoc:'Chinese documentation',
        enDoc:'English document',
        support:'*Only supports uploading pdf files',
        nowUpload:'Uploading, please wait...',
        question:'The document language does not match and cannot be selected',
        editTitle:'Double click to edit file name',

        uploadSuccess:'Uploaded successfully',
        sideBar:'Collapse sidebar',
        noData:'No parsable table found in the document',
        delConfirm:'Are you sure to delete this file?',
        unable:'Unable to parse the excel',
        delSuccess:'Delete successfully',
        selFile:'Please select file',
        inputName:'Please enter the session name',
        createSuccess:'Created successfully',
        fileTips:'The file is being converted, please try again later',
        failFile:'The file conversion failed, please upload again',
        defaultQuestion1:'What fields are included in the table and what data are described?',
        defaultQuestion2:'Please calculate the average of each column of data?',
        defaultQuestion3:'Please calculate the median of each column of data?',
        defaultQuestion4:'What is the value that appears most frequently in each column of data?',
        defaultQuestion5:'What information can we get from the data in the table, and what conclusions can we draw from the analysis?',
    },
    chatdata:{
        title:' Smart Data Analysis Tool',
        introduce:'By utilizing intelligent parsing and in-depth analysis, we reveal insights within your data. Through the use of visualization analysis, we achieve vivid presentations in the form of charts.',
        start:'Start experiencing',
        ask:'Ask questions about the current documentation and get the answers',
        create:' a conversation and ask questions on multiple documents simultaneously',
        quoting:'Quoting passages and in-depth analysis of  contents',
        analyze:'Analyze charts and extract data for comprehensive analysis',
        tool:"File Analysis Tool",
        list:'File list',
        conversation:'Conversation list',
        createAsk:'Create a conversation',
        upload:'File Upload',
        drag:'Drag in files or click to upload',
        introduceOne:'ChatData enables conversational querying with tables and datasets through intelligent parsing. Additionally, it automatically generates visual charts through in-depth analysis, making data easily comprehensible at a glance!',
       
        quick:'Quick Access',
        enter:'Please enter contents...',
        hint:'Hint',
        hintOne:'This module is under maintenance and is temporarily unavailable. Thank you for your understanding and patience',
        Isee:'I see',
    },
    chatopen:{
        title:'Your open knowledge discovery engine',
        switch:'Switch to traditional search',
        introduce:'Obtain and discover the latest scientific research results in physics, mathematics, computer science, artificial intelligence, statistics, etc., and grasp development trends',
        features:'Features',
        featureOne:"Use artificial intelligence and advanced technology to provide scientific researchers with a more efficient, powerful, and accurate knowledge discovery experience. ChatOpen applies semantic retrieval technology to achieve in-depth understanding of readers' search intentions, interests and cross-language mapping.",
        featureTwo:'Integrate massive open knowledge metadata to provide scientific readers with multiple types of open source academic results including open access documents, preprints, etc. Combined with semantic discovery, we hope these resources can help you promote academic research innovation and connect you with open future.',
        translate:'Translate',
        clear:'Clear filter'
    },
    message:{
        authority: "No permission",
        upload: "Only .jpg/.png formats are supported!",
        apply: "Trial application submitted, please wait patiently!",
        delete: "Are you sure you want to delete this file?",
        size: "File size cannot exceed 20MB",
        wait: "Processing, please wait"
    }
}
